import React from 'react'
import {Box, Typography} from '@mui/material'
import moment from 'moment'
import AppDialog from 'src/components-new/feedback/AppDialog'
import ReadOnlyField from 'src/components-new/inputs/ReadOnlyField'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface PharmacyDetailDialogNewProps {
  open: boolean
  onClose: () => void
  detail?: Record<string, any>
}

const PHARMACY_TYPE_LABELS: Record<string, string> = {
  HOSPITAL: 'Ospedaliera',
  EXTERNAL: 'Esterna',
}

function SectionTitle({children}: {children: string}): JSX.Element {
  return (
    <Typography
      variant="h2"
      sx={{fontSize: 13, fontWeight: 700, color: NEUTRAL_SCALE[700], mb: 2, textTransform: 'uppercase', letterSpacing: 0.5}}
    >
      {children}
    </Typography>
  )
}

function TwoColGrid({children}: {children: React.ReactNode}): JSX.Element {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, 1fr)'},
        gap: 2,
      }}
    >
      {children}
    </Box>
  )
}

export default function PharmacyDetailDialogNew({open, onClose, detail}: PharmacyDetailDialogNewProps): JSX.Element {
  const title = detail?.name || 'Dettaglio farmacia'

  return (
    <AppDialog open={open} onClose={onClose} title={title} maxWidth="md">
      <Box sx={{display: 'flex', flexDirection: 'column', gap: 3}}>
        <Box>
          <SectionTitle>Dati principali</SectionTitle>
          <TwoColGrid>
            <ReadOnlyField label="Codice" value={detail?.code} />
            <ReadOnlyField label="Tipo" value={PHARMACY_TYPE_LABELS[detail?.type] ?? detail?.type} />
            <ReadOnlyField
              label="Data inserimento"
              value={detail?.createdAt ? moment(detail.createdAt).format('ddd DD MMM YYYY HH:mm') : undefined}
            />
            <ReadOnlyField label="Orari farmacia" value={detail?.openingTimes} />
            <ReadOnlyField label="Nome" value={detail?.name} />
          </TwoColGrid>
        </Box>

        <Box>
          <SectionTitle>Dati di contatto</SectionTitle>
          <TwoColGrid>
            <ReadOnlyField label="Telefono" value={detail?.phoneNumber} />
            <ReadOnlyField label="Fax" value={detail?.fax} />
            <ReadOnlyField label="Email" value={detail?.email} />
            <ReadOnlyField label="Regione" value={detail?.address?.region} />
            <ReadOnlyField label="Provincia" value={detail?.address?.province} />
            <ReadOnlyField label="Città" value={detail?.address?.city} />
            <ReadOnlyField label="Indirizzo" value={detail?.address?.address} />
            <ReadOnlyField label="Civico" value={detail?.address?.streetNumber} />
            <ReadOnlyField label="Codice Postale" value={detail?.address?.postalCode} />
            <ReadOnlyField label="Località" value={detail?.address?.locality} />
          </TwoColGrid>
        </Box>
      </Box>
    </AppDialog>
  )
}
